<template>
  <base-account :menu="false">
    <Aguarde :show="httpSend"></Aguarde>
    <section class="section hero-section bg-ico-hero" id="home">
      <div class="bg-overlay bg-primary"></div>
      <div class="container" style="margin-top: -6%">
        <div class="card">
          <div class="row">
            <div class="col-md-12 text-right">
              <button type="button" @click="baixar_nota()" class="btn btn-danger btn-lg mb-10 mt-3 mr-3">Baixar Nota
                Fiscal <i
                    class="mdi mdi-download d-block font-size-16"></i></button>
            </div>
          </div>
          <div class="row justify-content-center mt-1">
            <div v-if="filePDF" class="col-md-12">
              <div class="card p-3">
                <embed :src="filePDF" style="width:100%; height:120em;" type="text/html">
              </div>
              <div class="col-md-12 text-right">
                <button type="button" @click="baixar_nota()" class="btn btn-danger btn-lg mb-10 mr-3 mb-3">Baixar
                  Nota
                  Fiscal <i
                      class="mdi mdi-download d-block font-size-16"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </base-account>
</template>
<script>
import BaseAccount from "@/router/layouts/base-account"
import Aguarde from "@/components/widgets/aguarde";
import {setRelNotaFiscal} from "@/api/relatorio/nota_fiscal";
import {urlTemp} from "@/helps/impressao";
import {downloadNota} from "@/api/nfse/nota";

export default {
  components: {
    BaseAccount,
    Aguarde,
  },
  data() {
    return {
      httpSend: false,
      filePDF: '',
    };
  },
  created() {
    this.getNota();
  },
  methods: {
    getNota() {
      this.httpSend = true;
      urlTemp(setRelNotaFiscal(this.$route.params.not_hash)).then(result => {
        this.filePDF = result;
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    baixar_nota() {
      this.httpSend = true;
      downloadNota(this.$route.params.not_hash).then(result => {
        if (result.status) {
          window.open(result.mensagem, '_blank');
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
  }
};
</script>

